import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=bfae1498&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfae1498",
  null
  
)

export default component.exports